import { useEffect, useState } from "react";
import { Area, AreaChart, ResponsiveContainer, Tooltip } from "recharts";
import { getVisitsByDay } from "./charts-api";
import type { VisitsByDayPoint } from "./charts-api";

export function VisitsSparkline() {
  const [data, setData] = useState<VisitsByDayPoint[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    getVisitsByDay(7, controller.signal)
      .then(setData)
      .catch(() => setData(null));
    return () => controller.abort();
  }, []);

  const total = data?.reduce((sum, point) => sum + point.count, 0) ?? null;

  return (
    <article className="stat-card">
      <p className="stat-label">Visits (last 7 days)</p>
      {data ? (
        <>
          <p className="stat-value">{total}</p>
          <ResponsiveContainer width="100%" height={48}>
            <AreaChart data={data}>
              <defs>
                <linearGradient id="sparklineFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#ea580c" stopOpacity={0.35} />
                  <stop offset="100%" stopColor="#ea580c" stopOpacity={0.03} />
                </linearGradient>
              </defs>
              <Tooltip
                labelFormatter={() => ""}
                formatter={(value: number) => [`${value} visits`, ""]}
              />
              <Area type="monotone" dataKey="count" stroke="#ea580c" fill="url(#sparklineFill)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </>
      ) : (
        <div className="skeleton skeleton-row" />
      )}
    </article>
  );
}
